import { Link, useLocation } from 'react-router-dom';
import { Home, Calendar, Crosshair, Trophy, CircleUser, Crown, LogIn } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';

export function MobileBottomNav() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  const isActive = (path: string) =>
    path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);

  const authLinks = [
    { to: '/matches',     icon: Calendar,    label: 'Partidos' },
    { to: '/predictions', icon: Crosshair,   label: 'Picks'    },
    { to: '/pricing',     icon: Crown,       label: 'Planes'   },
    { to: '/my-bets',     icon: Trophy,      label: 'Apuestas' },
    { to: '/profile',     icon: CircleUser,  label: 'Perfil'   },
  ];

  const guestLinks = [
    { to: '/',        icon: Home,  label: 'Inicio' },
    { to: '/pricing', icon: Crown, label: 'Planes' },
    { to: '/login',   icon: LogIn, label: 'Entrar' },
  ];

  const links = isAuthenticated ? authLinks : guestLinks;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-slate-900/95 backdrop-blur-lg border-t border-slate-800 safe-area-inset-bottom">
      <div className="flex items-stretch">
        {links.map(({ to, icon: Icon, label }) => {
          const active = isActive(to);
          return (
            <Link
              key={to}
              to={to}
              className={`flex flex-col items-center justify-center gap-0.5 py-2 flex-1 min-h-[56px] relative transition-colors ${
                active ? 'text-blue-400' : 'text-slate-500 hover:text-slate-300'
              }`}
            >
              {active && (
                <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 rounded-full bg-blue-400" />
              )}
              <Icon className={`w-5 h-5 ${active ? 'stroke-[2.5]' : 'stroke-2'}`} />
              <span className={`text-[10px] leading-none font-medium ${active ? 'text-blue-400' : ''}`}>
                {label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
